import ModalInterventionDetails from '@/app/components/action-plan/components/modals/details/modal-intervention-details';
import { Intervention } from '@/app/components/action-plan/types';
import icons from '@/assets/icons';
import { RiskBadge } from '@/app/components/common';
import { formatCancerAndOthersNameText, formatCancerAndOthersRiskNameText, formatRiskDecimal } from '@/utils';
import useActiveInterventionCardController from './active-intervention-card.controller';
import { DownArrow } from '@/components/icons/down-arrow';

type ActiveInterventionCardProps = {
  intervention: Intervention;
  onCompleteIntervention?: (intervention: Intervention) => void;
};

export default function ActiveInterventionCard({ intervention, onCompleteIntervention }: ActiveInterventionCardProps) {
  const { cancersAffected, isDetailsModalOpen, onCloseDetailsModal, onOpenDetailsModal, otherCancers, reducedRisk } =
    useActiveInterventionCardController({ intervention });
  const { title, category, isNonQuantifiable } = intervention;

  return (
    <section className="dashboard-reset intervention-card-container">
      <div className="intervention-card-header">
        <div className="intervention-card-icon-container">
          <div className="intervention-card-icon-wrapper">
            <img
              src={icons[category as keyof typeof icons] || ''}
              alt=""
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        <div className="intervention-card-risk-badge">
          {formatCancerAndOthersNameText({ reducedRisk, isNonQuantifiable, otherCancers })}
        </div>
      </div>

      <div className="intervention-card-content">
        <h2 className="intervention-card-title">
          {title}
        </h2>
        <div className="intervention-card-risk-info">
          <RiskBadge
            value={parseFloat(formatRiskDecimal(reducedRisk.impact))}
            variant="success"
            badgeType="change"
            showPercent={true}
            icon={
              <DownArrow/>
            }
          />
          <span className="intervention-card-risk-text">
            {formatCancerAndOthersRiskNameText({ reducedRisk, cancersAffected, otherCancers })}
          </span>
        </div>
      </div>

      <div className="intervention-card-actions">
        <button
          className="intervention-card-btn-details"
          onClick={onOpenDetailsModal}
        >
          Details
        </button>
        <button
          className="intervention-card-btn-complete"
          onClick={() => {
            if (onCompleteIntervention) onCompleteIntervention(intervention);
          }}
        >
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z" fill="currentColor"/>
          </svg>
          Mark as Complete
        </button>
      </div>
      <ModalInterventionDetails isOpen={isDetailsModalOpen} onClose={onCloseDetailsModal} intervention={intervention} navToActionPlanHome={true} />
    </section>
  );
}
